
export default function sketch2(p) {
  let particles = [];
  const numParticles = 20;

  p.setup = () => {
    p.createCanvas(p.windowWidth, p.windowHeight);
    for (let i = 0; i < numParticles; i++) {
      particles.push({
        x: p.random(p.width),
        y: p.random(p.height),
        vx: p.random(-1, 1),
        vy: p.random(-1, 1),
        size: p.random(2, 6),
        color: p.color(p.random(100, 255), p.random(100, 255), p.random(100, 255), 150),
      });
    }
  };

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  p.draw = () => {
    p.background(20, 20, 40, 25); // Semi-transparent background for a trailing effect
    particles.forEach((particle) => {
      p.fill(particle.color);
      p.noStroke();
      p.circle(particle.x, particle.y, particle.size);

      // Update position
      particle.x += particle.vx;
      particle.y += particle.vy;

      // Bounce off edges
      if (particle.x < 0 || particle.x > p.width) particle.vx *= -1;
      if (particle.y < 0 || particle.y > p.height) particle.vy *= -1;
    });
  };
}